
// the Dev settings, apart from their module and panel: the toggle provider reads them, and the panel imports it back.
export const devSettingsType = 'dev'

export type DevSettings = {

    autoMatchAndValidate: boolean
    enabledFeatures: string[]   // toggles released to all users, beta testers or not.
}
